import React from 'react';
import styled from 'styled-components';
import theme from '../../../assets/css/theme';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { getTranslationKey } from '../../../modules/utils';
import { ButtonPrimary } from '../..';
import { usePreventBodyPaddingShift } from '../../../hooks/usePreventBodyPaddingShift';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  title: React.ReactNode;
  children: React.ReactNode;
  saveLabel?: string;
  disableSave?: boolean;
  size?: string;
}

const CloseButton = styled(Button)`
  width: 100%;
  border-color: ${theme.commonColors.second};
  color: ${theme.commonColors.second};
  :hover {
    background-color: ${theme.commonColors.second};
    color: white;
  }
`;
const CustomModalFooter = styled(ModalFooter)<{ modalsize: string }>`
  justify-content: ${(props) => (props.modalsize === 'lg' ? 'flex-end !important' : '')};
  flex-wrap: nowrap;
  // Keeps both buttons the same height when one label wraps onto two lines.
  align-items: stretch;

  // Style the buttons to have 200px width when size is 'xl'
  & > button {
    width: ${(props) => (props.modalsize === 'lg' ? '250px !important' : '')};
  }
`;
export const CustomModal: React.FC<IProps> = ({
  isOpen,
  onClose,
  onSave,
  title,
  children,
  saveLabel,
  disableSave,
  size = 'Default'
}) => {
  usePreventBodyPaddingShift(isOpen);

  return (
    <Modal
      centered
      size={size}
      isOpen={isOpen}
      wrapClassName="modal-new"
      returnFocusAfterClose={false}
    >
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>{children}</ModalBody>
      <CustomModalFooter modalsize={size}>
        <CloseButton outline onClick={onClose}>
          {getTranslationKey('newDesign.modalCloseLabel')}
        </CloseButton>
        <ButtonPrimary
          style={{ width: '100%' }}
          className="btn btn-primary"
          type="submit"
          disabled={disableSave}
          onClick={onSave}
        >
          {saveLabel || getTranslationKey('newDesign.defaultModalSaveLabel')}
        </ButtonPrimary>
      </CustomModalFooter>
    </Modal>
  );
};
